export default "__VITE_ASSET__Bko4FoCR__"